<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - リリース情報登録完了</h3>
      </div>
      <div class="page-block__inner">
        <div class="form-complete-area">
          <div class="form-complete-area__title">著作権管理サービスを活用しよう！</div>
          <div class="form-complete-area__lead">
            あなたの楽曲の著作権をnarasuが正しく管理します。<br />
            著作権管理サービスで、新たな収益の可能性を広げましょう。<br />
            詳しくは<a
              class="c-text-link mt-30"
              target="_blank"
              href="https://narasu.jp/service/license/">こちら</a>
          </div>
          <div class="c-btn-wrap">
            <a
              class="c-btn c-btn--back m-35"
              @click="onCancel()">
              トップへ戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </a>
            <a
              v-if="showCreateCopyrightButton()"
              class="c-btn m-35"
              @click="createCopyright()">
              引き続き著作権申請をする
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'SubmitCanceled',
  components: { HeaderBar },
  data() {
    return {
      title: null,
      type: 'album',
      trackId: null,
      isEligibleForCopyright: false,
    }
  },
  async mounted() {
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release.type) {
      await this.$router.push({ name: 'index' })
      return
    }
    this.title = release.product.title_ja
    this.type = release.type
    if (this.type === 'single') {
      const { id } = release.discs[0].tracks[0]
      this.trackId = id
      await this.checkCopyrightEligibility()
    }
  },
  methods: {
    createCopyright() {
      if (this.type === 'single') {
        this.$router.push({ name: 'get-track', params: { id: this.trackId } })
      } else {
        this.$router.push({ name: 'copyright-index' })
      }
    },
    showCreateCopyrightButton() {
      return this.type === 'album' ? true
        : (this.type === 'single' && this.isEligibleForCopyright)
    },
    onCancel() {
      window.sessionStorage.removeItem('album')
      this.$router.push({ name: 'index' })
    },
    async checkCopyrightEligibility() {
      const { data } = await window.axios.get(`/api/client/copyrights/check-eligible/${this.trackId}`)
      this.isEligibleForCopyright = data.is_eligible ?? false
    },
  },
}
</script>
